// For showing set/question preview modal in library/recent
// `source` (optional) records where the preview was opened from (e.g.
// 'searchDropdown', 'searchResults', 'library', 'recent') for analytics.
export function updatePreviewItem(itemId, source = null) {
  return (dispatch) => dispatch({ type: 'UPDATE_PREVIEW_ITEM', itemId, source })
}
